import * as yup from 'yup';
import { AssetClassDTO, ModelDTO } from '../../api/useModelGroupsQuery';
import { hypotheticalReturnValidation } from '../../../../../CommonValidations/hypoteticalReturn';

export interface FormValues {
  orionModelId: string;
  modelName: string;
  modelDescription: string;
  hypotheticalReturn: number | string;
  assetAllocation: AssetClassDTO[] | null;
}

export interface FormContext {
  model: Partial<ModelDTO>;
  models: ModelDTO[];
}

export const validation = yup.object().shape({
  modelName: yup
    .string()
    .required('Model name is required')
    .test({
      name: 'modelNameAlreadyExists',
      message: 'Another model with the same name already exists in the group',
      test(value?: string) {
        if (!value) {
          return true;
        }

        const { model, models } = this.options.context as FormContext;

        if (!model || !models) {
          return true;
        }

        return !models.some(
          ({ id, portfolioName }) =>
            portfolioName.toLowerCase() === value.toLowerCase() && !(id === model.id),
        );
      },
    }),

  hypotheticalReturn: hypotheticalReturnValidation,
});
